import { forwardRef, Ref } from 'react';
import { Group, Modal } from '@mantine/core';
import { HEADER_HEIGHT } from '@/src/shared/constants/ui/header';
import { BackButton } from './back-button';
import { SearchInput } from './search-input';

interface IMobileSearchInputProps {
  onClose?: () => void;
}

export const MobileSearchInput = forwardRef(
  ({ onClose }: IMobileSearchInputProps, ref?: Ref<HTMLInputElement>) => {
    return (
      <Modal.Root
        opened
        onClose={() => {}}
        fullScreen
        transitionProps={{ transition: 'fade', duration: 200 }}
      >
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Body h={HEADER_HEIGHT} p={0}>
            <Group
              wrap="nowrap"
              align="center"
              h="100%"
              gap="0.5rem"
              mr="md"
              ml="0.3rem"
            >
              <BackButton onClick={onClose} />
              <SearchInput ref={ref} onClose={onClose} />
            </Group>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    );
  }
);
